import rill from "rill";
import set from "@rill/set";

import getCalendarDay from "./calendar-day.controller";
import getCalendarWeek from "./calendar-week.controller";
import getCalendarMonth from "./calendar-month.controller";

const Calendar = (app) => {
  app.at(
    "/calendar/*",
    rill()
      .use(set("heading", ["Athlete", "Calendar"]))
      .setup((app) =>
        app.get("/", getCalendarDay, getCalendarWeek, getCalendarMonth)
      )
  );
};

export default Calendar;
